import React, { useEffect, useState } from 'react';
import { formatTimeUntil } from '../../utils/helpers';

const TIME_UNTIL_UPDATE_INTERVAL_MS = 15000;

export interface JoinEventCardProps {
  title?: string | undefined;
  startTimeEpochSeconds?: number | undefined;
  className?: string | undefined;
}

const JoinEventCard: React.FC<JoinEventCardProps> = ({
  title,
  startTimeEpochSeconds,
  className = '',
}) => {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!startTimeEpochSeconds) return;
    const id = setInterval(() => setTick((t) => t + 1), TIME_UNTIL_UPDATE_INTERVAL_MS);
    return () => clearInterval(id);
  }, [startTimeEpochSeconds]);

  const titleText = title?.trim() || 'Untitled event';
  const timeText = startTimeEpochSeconds ? formatTimeUntil(startTimeEpochSeconds) : '';

  return (
    <article
      className={`join-event-card ${className}`.trim()}
      aria-label={`Join event: ${titleText}`}
      data-testid="join-event-card"
    >
      <div className="join-event-card-title" data-testid="join-event-card-title">{titleText}</div>
      {timeText && (
        <div className="join-event-card-time" data-testid="join-event-card-time">{timeText}</div>
      )}
    </article>
  );
};

export default JoinEventCard;
